$(document).ready(() => {
  /*
   * Set cookie function for disclaimer acceptance
   */
  function setDisclaimerCookie(name, value, days) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/; samesite=strict;';
  }

  /*
   * Set cookie function for disclaimer country
   */
  function setCountryCodeCookie(name, value, days){
    let expires = '';
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + (value || '')  + expires + '; path=/; samesite=strict;';
  }

  /*
   * Set cookie function for user role types
   */
  function setUserTypeCookie(name, value, days){
    let expires = '';
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + (value || '')  + expires + '; path=/; samesite=strict;';
  }

  /*
   * Return the value of a specified cookie
   */
  function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  /*
   * Show country disclaimer text on select field change
   */
  const $country = $('.disclaimer-form #countries');

  $country.change(function(){
    let countryCodeValue = $('option:selected').val();
    let $countryContent = $('.country-content');
    let $allowedCountries = $('.allowed-countries');

    $(this).find('option:selected').each(function(){
      if(countryCodeValue){
        // Show or hide country disclaimer text based on country selection.
        if($countryContent.hasClass(countryCodeValue)) {
          $countryContent.not('.'+countryCodeValue).hide();
          $('.'+countryCodeValue).show();
        } else {
          $countryContent.not('.'+countryCodeValue).hide();
        }

        // Set accept button to decline if not in country allow list
        if(!$allowedCountries.hasClass(countryCodeValue)) {
          $('.modal-footer button[name="accept"]').hide();
          $('.modal-footer button[name="not-allowed"]').show();
        } else {
          $('.modal-footer button[name="not-allowed"]').hide();
          $('.modal-footer button[name="accept"]').show();
        }
      }
    });
  });

  /*
   * Disclaimer form validation
   */
  window.addEventListener('load', function() {
    // Get disclaimer form
    const disclaimerForm = document.getElementsByClassName('disclaimer-form');

    // Loop over form and prevent submission
    const validation = Array.prototype.filter.call(disclaimerForm, function(form) {
      form.addEventListener('submit', function(event) {
        /*
         * Check if form submitted and set disclaimer cookies
         * based on accept or decline buttons
         */
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
          $('.modal-footer p').show();
        } else if ($('button[name="accept"]').click() && form.checkValidity() === true) {
          setDisclaimerCookie('disclaimer', 'accepted', 1);
          setCountryCodeCookie('countryCode', $('#countries').val(), 1);
          setUserTypeCookie('userType', $('#user-types').val(), 1);
        } else if ($('button[name="decline"]').click() && form.checkValidity() === true) {
          setDisclaimerCookie('disclaimer', 'declined', 1);
          window.location = $('.deny-url').data('deny-page');
        }

        form.classList.add('was-validated');
      }, false);
    });
  }, false);

  /*
   * Set disclaimer cookie to declined and redirect user
   * to disclaimer denied page if disclaimer declined,
   * or a country is selected that is not allowed.
   */
  const $declineButton = $('.disclaimer-form button[name="decline"]');
  const $notAllowedButton = $('.disclaimer-form button[name="not-allowed"]');

  $declineButton.click(function() {
    setDisclaimerCookie('disclaimer', 'declined', 1);
    window.location = $('.deny-url').data('deny-page');
  });

  $notAllowedButton.click(function() {
    if ($('.disclaimer-form')[0].checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setDisclaimerCookie('disclaimer', 'declined', 1);
      window.location = $('.deny-url').data('deny-page');
    }
    $('.disclaimer-form').addClass('was-validated');
  });

  /*
   * Show disclaimer only if cookie is not set or is declined.
   * Add classes to <body> based on cookie values set.
   */
  const disclaimerCookie = getCookie('disclaimer');
  const countryCodeCookie = getCookie('countryCode');
  let countryClassName = 'disclaimer-country-'+countryCodeCookie;

  if (disclaimerCookie === ''){
    $('#disclaimer').modal('show');
    $('.disclaimer-overlay').removeClass('hide');
    $('body').removeClass('disclaimer-accepted disclaimer-declined '+countryClassName);
  } else if (disclaimerCookie === 'accepted') {
    $('.disclaimer-overlay').addClass('hide');
    $('body').addClass('disclaimer-accepted '+countryClassName).removeClass('disclaimer-declined');
  } else if (disclaimerCookie === 'declined') {
    $('#disclaimer').modal('show');
    $('body').addClass('disclaimer-declined').removeClass('disclaimer-accepted '+countryClassName);
  }
});
